import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { GiBroom } from 'react-icons/gi';
import { useTranslation } from 'react-i18next';
//components
import Button from 'components/backoffice/buttonCustom';
import Input from 'components/backoffice/customInput';

const SearchModal = ({
  handleSearch,
  handleClear,
  value,
  multipleInput = false,
  children,
  placeholder,
  typeselect = false,
  handleKeyDown = false,
  className = ''
}) => {
  const { t } = useTranslation(['backoffice']);

  return (
    <div className="d-flex w-100">
      {multipleInput || typeselect ? (
        <div className={`${typeselect ? 'search-with-typeselect mt-0' : 'search-without-typeselect mt-0'} ${className}`}>
          <div className="d-flex align-items-center w-100">
            {children}
          </div>
        </div>) : (
        <Col md={multipleInput && 5 } className={`d-flex align-items-center ${multipleInput ? 'mt-5' : 'mt-0'} ${!multipleInput && 'search-input'}`}>
          <div className='w-100'>
            <Input
              handleKeyDown={handleKeyDown}
              onChange={(e) => handleSearch(e)}
              placeholder={placeholder === undefined ? t('search') + '...' : placeholder}
              value={value}
              icon={<BsSearch color="#161A25" className="icon-search" />}
              type='text'
            />
          </div>
        </Col>
      )}
      <Col md={2} className={`${multipleInput ? 'text-start d-flex align-items-end ms-3 mt-0' : 'text-start d-flex align-items-center ms-3 mt-0'}`}>
        <Button onClick={handleClear} color="terciary" role="button">
          <GiBroom />
        </Button>
      </Col>
    </div>
  );
};

SearchModal.propTypes = {
  value: PropTypes.string,
  handleClear: PropTypes.func.isRequired,
  handleSearch: PropTypes.func,
  multipleInput: PropTypes.bool,
  typeselect: PropTypes.bool,
  children: PropTypes.any,
  placeholder: PropTypes.string,
  handleKeyDown: PropTypes.bool,
  className: PropTypes.string,
};

export default SearchModal;
